import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  TuiButtonModule,
  TuiDataListModule,
  TuiDropdownModule,
  TuiFlagPipeModule,
  TuiHostedDropdownModule,
  TuiSvgModule,
} from '@taiga-ui/core';
import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { LanguageService } from '@shared/services/language.service';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';

@Component({
  selector: 'app-language-select',
  standalone: true,
  imports: [
    TranslocoPipe,
    TuiDataListModule,
    TuiDropdownModule,
    TuiHostedDropdownModule,
    UpperCasePipe,
    TuiSvgModule,
    TuiButtonModule,
    AsyncPipe,
    TuiFlagPipeModule,
  ],
  templateUrl: './language-select.component.html',
  styleUrl: './language-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSelectComponent {
  language$ = this.languageService.getLanguageObservable();

  protected readonly TuiCountryIsoCode = TuiCountryIsoCode;
  constructor(private readonly languageService: LanguageService) {}

  setLang(lang: TuiCountryIsoCode) {
    this.languageService.setLanguage(lang);
  }
}
